import { default as Mui4Snackbar, SnackbarProps as Mui4SnackbarProps } from '@material-ui/core/Snackbar'
import {
  default as Mui5Snackbar,
  SnackbarCloseReason as Mui5SnackbarCloseReason,
  SnackbarProps as Mui5SnackbarProps,
} from '@mui/material/Snackbar'
import { forwardRef, ReactElement } from 'react'
import { useComponentVersion } from '../hooks'

export enum OsSnackbarVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type SnackbarCloseReason = Mui5SnackbarCloseReason
export type SnackbarProps = Mui4SnackbarProps

export const Snackbar = forwardRef<HTMLDivElement, SnackbarProps>((props, ref) => {
  const version = useComponentVersion('snackbar')

  switch (version) {
    case OsSnackbarVersion.V2: {
      const { ClickAwayListenerProps, ContentProps, onClose, ...rest } = props
      // Extract onClickAway to avoid type conflicts between MUI4 and MUI5
      const { onClickAway, ...restClickAwayProps } = ClickAwayListenerProps || {}

      const safeClickAwayProps = {
        ...restClickAwayProps,
        children: ClickAwayListenerProps?.children as ReactElement<any>,
        ...(onClickAway
          ? { onClickAway: onClickAway as (event) => void }
          : { mouseEvent: false as const, touchEvent: false as const }),
      }

      return (
        <Mui5Snackbar
          ref={ref}
          {...rest}
          ClickAwayListenerProps={safeClickAwayProps}
          ContentProps={ContentProps as Mui5SnackbarProps['ContentProps']}
          onClose={onClose as (event, reason) => void}
        />
      )
    }
    default:
      return <Mui4Snackbar {...props} />
  }
})
